import { useState } from "react";
import Loader from "../../../Loader/Index";
import PositiveNegativeButton from "../../CommonButtons/PositiveNegativeButton";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";
import ICONS from "../../../../assets/Icons";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
import TopNavLargeButton from "../../CommonButtons/TopNavLargeButton";

const TimelineStatusBar = ({
  hasDistributionData = true,
  isLoading,
  showMobile,

  failedToTakeaction,
  failedToTakeIcon,
  failedToTakeactionReason,

  approvalNotPossible,
  approvalNotPossibleIcon,
  approvalNotPossibleSubHeader,
  isApprovalNotPossibleDisabled,
  handleApprovalNotPossibleBtn,

  rejected,
  rejectedReason,

  furtherApprovalPending,
  furtherApprovalPendingSubHeader = "",

  accountApprovalPending,
  accountApprovalPendingSubHeader,
  isApprovalPendingDisabled,
  handleApprovalPendingBtn,

  blocked,

  cancelled,
  cancelledReason,

  pending,
  overrideAutoLoader,
  whichBtnClicked,
  rejectClick,
  approveClick,
  isRejectDisable,
  isApproveDisable,

  requestApproval,
  handleRequestApproval,
  isReqDisable,

  failed,
  failedReason = "",

  processing,

  uploaded,

  created,
  createText,
  isCreateDisabled,
  handleCreateBtn,

  requireAuthentication,
  handleReqAuthFunction,
  isrequireAuthDisabled,

  authenticationPending,
  handleAuthFunction,
  isAuthDisabled,

  otp,
  isOtpDisabled,
  handleOtpFunction,
  otpSubHeader,
  otpHeader,

  recreate,
  recreateReason,
  handleRecreateBtn,
  isRecreateDisabled,
  recreateBtnNeeded,

  rejectMobClick,
  approveMobClick,
  isApproveMobDisable,
  isRejectMobDisable,

  approveBtnText,
  rejectBtnText,
}) => {
  const [btnClicked, setbtnClicked] = useState("none");

  const shouldRender =
    isLoading ||
    failedToTakeaction ||
    approvalNotPossible ||
    rejected ||
    furtherApprovalPending ||
    accountApprovalPending ||
    blocked ||
    cancelled ||
    pending ||
    failed ||
    processing ||
    uploaded ||
    created ||
    requireAuthentication ||
    authenticationPending ||
    recreate ||
    requestApproval ||
    otp;

  let clickedBtn;
  if (overrideAutoLoader) {
    clickedBtn = whichBtnClicked;
  } else {
    clickedBtn = btnClicked;
  }

  const render = () => {
    return isLoading ? (
      <div
        className={`flex justify-center items-center w-full h-full  ${showMobile ? "w-full p-padding-md" : ""}`}
      >
        <Loader
          height="var(--icon-lg)"
          width="var(--icon-lg)"
        />
      </div>
    ) : failedToTakeaction ? (
      <div
        className={`flex flex-col gap-gap-xs bg-negative-card h-height-full   ${showMobile ? "w-full p-padding-md" : "rounded-br-border-radius-md rounded-tr-border-radius-md py-padding-sm px-padding-md"}`}
      >
        <div className="flex gap-gap-xs">
          {failedToTakeIcon && (
            <img
              className="w-icon-md h-icon-md"
              src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
              alt="icon"
            />
          )}
          <p className="text-text-primary text-font-sm font-semibold mb-margin-xs">
            Failed to take action
          </p>
        </div>
        <p className="text-text-secondary text-font-xs line-clamp-2">
          {failedToTakeactionReason ||
            "An error occurred while taking action on this transaction."}
        </p>
      </div>
    ) : approvalNotPossible ? (
      <div
        className={`flex flex-col gap-gap-sm bg-negative-card h-height-full  ${showMobile ? "w-full p-padding-md" : "rounded-br-border-radius-md rounded-tr-border-radius-md py-padding-sm px-padding-md"}`}
      >
        <div className="flex flex-col gap-gap-xs">
          <div className="flex gap-gap-xs">
            {approvalNotPossibleIcon && (
              <img
                className="w-icon-md h-icon-md"
                src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                alt="icon"
              />
            )}
            <p className="text-text-primary text-font-sm font-semibold mb-margin-xs">
              Approval not possible
            </p>
          </div>
          <p className="text-text-secondary text-font-xs line-clamp-2">
            {approvalNotPossibleSubHeader ||
              "An error occurred while taking action on this transaction."}
          </p>
        </div>

        <div>
          <PrimaryWithIconButton
            hoverOption="dark"
            btnText="Send for recreation"
            iconToBeAlign="right"
            icon="https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
            imgColor="var(--text-primary)"
            enabledBgColor="var(--negative-bg)"
            isDisabled={isApprovalNotPossibleDisabled}
            handleFunction={handleApprovalNotPossibleBtn}
            enabledTextColor="var(--text-primary)"
          />
        </div>
      </div>
    ) : recreate ? (
      <div
        className={`flex min-w-0 h-full flex-1
        ${
          showMobile
            ? !recreateBtnNeeded
              ? "rounded-bl-border-radius-md rounded-br-border-radius-md"
              : ""
            : "rounded-tr-border-radius-md rounded-br-border-radius-md"
        }`}
      >
        <div
          className={`bg-primary-nav w-full ${
            showMobile
              ? !recreateBtnNeeded
                ? "rounded-bl-border-radius-md rounded-br-border-radius-md"
                : ""
              : "rounded-tr-border-radius-md rounded-br-border-radius-md"
          }`}
        >
          <div
            className={`flex flex-col h-full ${recreateBtnNeeded ? "gap-gap-sm" : "justify-between"}`}
          >
            <div
              className={`flex flex-col gap-gap-xs ${recreateBtnNeeded ? "pt-padding-sm" : "py-padding-sm"}  mx-margin-md ${showMobile ? "border-t border-primary-bg" : ""}`}
            >
              <p className="text-failed text-font-sm font-semibold">
                Rejected reason
              </p>
              <div className="text-text-secondary text-font-xs break-all line-clamp-3 overflow-hidden">
                {recreateReason}
              </div>
            </div>
            {recreateBtnNeeded ? (
              <div
                className={`${showMobile ? "ml-margin-md pb-padding-md" : "px-padding-md"} `}
              >
                <PrimaryWithIconButton
                  hoverOption="white"
                  btnText="Recreate transaction"
                  iconToBeAlign="right"
                  icon="https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  imgColor="var(--text-primary)"
                  enabledBgColor="var(--primary-bg)"
                  isDisabled={isRecreateDisabled}
                  handleFunction={handleRecreateBtn}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              <div
                className={`text-text-primary font-normal text-font-xs bg-primary-nav-act py-padding-sm px-padding-md  
                ${showMobile ? "rounded-bl-border-radius-md rounded-br-border-radius-md" : "rounded-br-border-radius-md"}`}
              >
                This transaction has been recreated.
              </div>
            )}
          </div>
        </div>
      </div>
    ) : accountApprovalPending ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className="flex flex-col gap-gap-xs">
            <p className="text-pending text-font-sm font-semibold">
              Account approval pending
            </p>
            <p className="text-text-secondary text-font-xs break-words">
              {accountApprovalPendingSubHeader ||
                "Account is not approved, approve account before approving transaction."}
            </p>
            <div>
              <PrimaryWithIconButton
                hoverOption="white"
                btnText="Approve account"
                iconToBeAlign="right"
                icon="https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                imgColor="var(--text-primary)"
                enabledBgColor="var(--primary-bg)"
                isDisabled={isApprovalPendingDisabled}
                handleFunction={handleApprovalPendingBtn}
                enabledTextColor="var(--text-primary)"
              />
            </div>
          </div>
        </div>
      </div>
    ) : rejected ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className="flex flex-col gap-gap-xs">
            <p className="text-failed text-font-sm font-semibold">
              Rejected reason
            </p>
            <p className="text-text-secondary text-font-xs break-words">
              {rejectedReason}
            </p>
          </div>
        </div>
      </div>
    ) : furtherApprovalPending ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className="flex flex-col gap-gap-xs">
            <p className="text-pending text-font-sm font-semibold">
              Further approval pending
            </p>
            <p className="text-text-secondary text-font-xs">
              {furtherApprovalPendingSubHeader ||
                "This transaction requires another user's approval before distribution."}
            </p>
          </div>
        </div>
      </div>
    ) : requestApproval ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div
            className={`flex flex-col h-full ${showMobile ? "gap-gap-xs" : " justify-between"}`}
          >
            <p className="text-settled text-font-sm font-semibold font-sans">
              Request approved and transaction created
            </p>
            <div>
              <PrimaryWithIconButton
                iconToBeAlign="right"
                btnText="View transaction"
                btnType="button"
                handleFunction={handleRequestApproval}
                isDisabled={isReqDisable}
                enabledBgColor="var(--primary-bg)"
                disabledBgColor="var(--primary-bg)"
                disabledTextColor="var(--text-primary)"
                enabledTextColor="var(--text-primary)"
                icon="https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                imgColor="var(--text-primary)"
                hoverOption="white"
              />
            </div>
          </div>
        </div>
      </div>
    ) : blocked ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className="flex flex-col gap-gap-xs">
            <p className="text-failed text-font-sm font-semibold">Blocked</p>
            <p className="text-text-secondary text-font-xs break-words line-clamp">
              This transaction has been blocked permanently due to multiple
              failed OTP authentication attempts.
            </p>
          </div>
        </div>
      </div>
    ) : cancelled ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className="flex flex-col gap-gap-xs">
            <p className="text-failed text-font-sm font-semibold">
              Rejected reason
            </p>
            <p className="text-text-secondary text-font-xs break-words line-clamp">
              {cancelledReason}
            </p>
          </div>
        </div>
      </div>
    ) : failed ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className="flex flex-col gap-gap-xs">
            <p className="text-failed text-font-sm font-semibold">
              Error summary
            </p>
            <p className="text-text-secondary text-font-xs break-words">
              {failedReason}
            </p>
          </div>
        </div>
      </div>
    ) : processing || uploaded ? (
      <div
        className={`h-height-full flex flex-col gap-gap-xs ${showMobile ? "w-full p-padding-md" : "rounded-br-border-radius-md rounded-tr-border-radius-md py-padding-sm px-padding-md"}`}
      >
        <p className={"text-queued text-font-sm font-semibold"}>
          File processing
        </p>
        <p
          className={"text-text-secondary text-font-xs font-normal line-clamp"}
        >
          You will receive a notification by mail once the file is processed.
        </p>
      </div>
    ) : created ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div
            className={`flex flex-col h-full ${showMobile ? "gap-gap-xs" : " justify-between"}`}
          >
            <p className="text-pending text-font-sm font-semibold">
              {createText || "Validation pending"}
            </p>
            <div>
              <PrimaryWithIconButton
                hoverOption="white"
                btnText="Validate file"
                iconToBeAlign="right"
                icon={
                  "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                }
                imgColor="var(--text-primary)"
                enabledBgColor="var(--primary-bg)"
                fullWidthRequired={false}
                isDisabled={isCreateDisabled}
                handleFunction={handleCreateBtn}
                enabledTextColor="var(--text-primary)"
              />
            </div>
          </div>
        </div>
      </div>
    ) : requireAuthentication ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className={`flex flex-col h-full gap-gap-sm`}>
            <div className="flex flex-col gap-gap-xs">
              <p className={"text-pending text-font-sm font-semibold "}>
                Require authentication
              </p>
              <p className={"text-text-secondary text-font-xs"}>
                This transaction has been approved. Authorization pending
              </p>
            </div>
            <div>
              <PrimaryButton
                enabledBgColor="var(--positive-act)"
                btnText="Authenticate with OTP"
                enabledTextColor="var(--text-primary)"
                handleFunction={handleReqAuthFunction}
                hoverOption="white"
                isDisabled={isrequireAuthDisabled}
                disabledBgColor="var(--positive-act)"
                disabledTextColor="var(--text-primary)"
              />
            </div>
          </div>
        </div>
      </div>
    ) : otp ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className={`flex flex-col h-full gap-gap-sm`}>
            <div className="flex flex-col gap-gap-xs">
              <p className={"text-pending text-font-sm font-semibold "}>
                {otpHeader}
              </p>
              <p className={"text-text-secondary text-font-xs"}>
                {otpSubHeader}
              </p>
            </div>
            <div>
              <PrimaryButton
                enabledBgColor="var(--positive-act)"
                btnText="Authenticate with OTP"
                enabledTextColor="var(--text-primary)"
                handleFunction={handleOtpFunction}
                hoverOption="dark"
                isDisabled={isOtpDisabled}
                disabledBgColor="var(--positive-act)"
                disabledTextColor="var(--text-primary)"
              />
            </div>
          </div>
        </div>
      </div>
    ) : authenticationPending ? (
      <div
        className={`bg-primary-nav w-full ${!showMobile ? "rounded-br-border-radius-md rounded-tr-border-radius-md h-full" : ""}`}
      >
        <div
          className={`h-full ${showMobile ? "py-padding-md mx-margin-md border-t border-primary-bg" : "py-padding-sm px-padding-md"}`}
        >
          <div className={`flex flex-col h-full gap-gap-sm`}>
            <div className="flex flex-col gap-gap-xs">
              <p className={"text-pending text-font-sm font-semibold "}>
                Authentication pending
              </p>
              <p className={"text-text-secondary text-font-xs"}>
                This transaction has been approved. Authentication pending
              </p>
            </div>
            <div>
              <PrimaryButton
                enabledBgColor="var(--positive-act)"
                btnText="Authenticate with OTP"
                enabledTextColor="var(--text-primary)"
                handleFunction={handleAuthFunction}
                hoverOption="dark"
                isDisabled={isAuthDisabled}
                disabledBgColor="var(--positive-act)"
                disabledTextColor="var(--text-primary)"
              />
            </div>
          </div>
        </div>
      </div>
    ) : pending ? (
      showMobile ? (
        <div className="w-width-full">
          {clickedBtn !== "none" ? (
            <div className="w-full flex h-full ">
              <div
                className={`w-width-full flex justify-center items-center p-padding-md ${
                  clickedBtn === "reject" || clickedBtn === "Reject"
                    ? "bg-negative-act"
                    : "bg-positive-act"
                }`}
              >
                <Loader
                  height="var(--icon-lg)"
                  width="var(--icon-lg)"
                />
              </div>
            </div>
          ) : (
            <div
              className={`flex flex-row w-width-full h-height-full justify-center overflow-hidden `}
            >
              <TopNavLargeButton
                btnText={rejectBtnText || "Reject transaction"}
                btnType="button"
                handleFunction={rejectMobClick}
                isDisabled={isRejectMobDisable}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--negative-act)"
                disabledBgColor="var(--negative-act)"
                isLoading={false}
                icon={ICONS?.REJECT_ICON_RED}
                hoverOption="black"
                width="var(--width-md)"
                fullWidthRequired={true}
              />

              <TopNavLargeButton
                btnText={approveBtnText || "Approve transaction"}
                btnType="button"
                handleFunction={approveMobClick}
                isDisabled={isApproveMobDisable}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--positive-act)"
                disabledBgColor="var(--positive-act)"
                isLoading={false}
                icon={ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK}
                hoverOption="black"
                width="var(--width-md)"
                fullWidthRequired={true}
              />
            </div>
          )}
        </div>
      ) : (
        <div className={`flex w-full justify-end pt-padding-md h-full`}>
          {clickedBtn !== "none" ? (
            <div className="w-max-button-width-for-approval-animation flex h-full">
              <div
                className={`w-width-full flex justify-center items-center rounded-tl-border-radius-md rounded-br-border-radius-md ${
                  clickedBtn === "reject" || clickedBtn === "Reject"
                    ? "bg-negative-act"
                    : "bg-positive-act"
                }`}
              >
                <Loader
                  height="var(--icon-lg)"
                  width="var(--icon-lg)"
                />
              </div>
            </div>
          ) : (
            <>
              <PositiveNegativeButton
                btnText={rejectBtnText || "Reject transaction"}
                icon={ICONS.REJECT_ICON_RED}
                handleFunction={() => {
                  if (!overrideAutoLoader) setbtnClicked("reject");
                  rejectClick?.();
                }}
                enabledBgColor="var(--negative-act)"
                enabledTextColor="var(--text-primary)"
                isDisabled={isRejectDisable}
                borderRadiusTopLeft
              />

              <PositiveNegativeButton
                btnText={approveBtnText || "Approve transaction"}
                icon={ICONS.APPROVE_CIRCLE_GREEN_CHECKMARK}
                handleFunction={() => {
                  if (!overrideAutoLoader) setbtnClicked("approve");
                  approveClick?.();
                }}
                enabledBgColor="var(--positive-act)"
                enabledTextColor="var(--text-primary)"
                isDisabled={isApproveDisable}
                borderRadiusBottomRight
              />
            </>
          )}
        </div>
      )
    ) : null;
  };

  return (
    <>
      {shouldRender ? (
        showMobile ? (
          <div
            className={`lg:hidden flex w-full ${showMobile && !recreateBtnNeeded ? "rounded-bl-border-radius-md rounded-br-border-radius-md" : ""}`}
          >
            {render()}
          </div>
        ) : (
          <div
            className={`Qsmd:flex hidden flex-col mt-margin-md w-full ${blocked || rejected || cancelled || recreate ? "h-privatetxn-recreate-timeline-status-bar-height" : "h-timeline-status-bar-default-height"} rounded-tr-border-radius-md rounded-br-border-radius-md`}
          >
            <div className="p-padding-md"></div>
            <div className="flex h-full">
              <div className="bg-primary-card flex h-full w-full rounded-tr-border-radius-md rounded-br-border-radius-md">
                <div
                  className={`bg-primary-card 
                    ${hasDistributionData ? "p-padding-md" : "max-w-max-width-timeline-status-box"} 
                    flex-1 min-w-0`}
                ></div>

                <div className="bg-primary-nav flex-1  min-w-min-width-timeline-status-box h-full rounded-tr-border-radius-md rounded-br-border-radius-md">
                  {render()}
                </div>
              </div>
            </div>
          </div>
        )
      ) : null}
    </>
  );
};

export default TimelineStatusBar;
